import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  checkClientAuth,
  isEmpty,
  isSingleSelect,
  isNumber,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var module = "banner";
var moduleName = "Banner";
var modulePath = "/clientpanel/banner";
class Form extends Component {
  constructor(props) {
    super(props);
    checkClientAuth(this.props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        bannerTitle: "",
        bannerImage: "",
        bannerSequence: "",
        bannerLink: "",
        bannerDescription: "",
        bannerStatus: "",
        action: "add",
      },
      btndisabled: false,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      const params = {
        params:'' ,
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          const bannerStatus =
            result.bannerStatus === "A" ? "Active" : "Inactive";
          const status = {
            label: bannerStatus,
            value: result.bannerStatus,
          };
          var clientupdatedata = {
            bannerTitle: result.bannerTitle,
            bannerImage:
              result.bannerImage !== "" && result.bannerImage !== null
                ? result.bannerImage
                : "",
            bannerSequence: result.bannerSequence,
            bannerLink: result.bannerLink,
            bannerDescription: result.bannerDescription,
            bannerStatus: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    const  editorContent = $('#editorContent').val();
    var postObject = {
      bannerTitle: postData.bannerTitle,
      bannerImage: postData.bannerImage,
      bannerSequence: postData.bannerSequence,
      bannerLink: postData.bannerLink,
      bannerDescription: editorContent,
      bannerStatus: postData.bannerStatus?.value || "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method, 'ecom');
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"banner"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { bannerTitle, bannerSequence, bannerStatus } = props.fields;

  return {
    fields: ["bannerTitle", "bannerSequence", "bannerStatus"],

    validations: {
      bannerTitle: [[isEmpty, bannerTitle]],
      bannerStatus: [[isSingleSelect, bannerStatus]],
      bannerSequence: [[isNumber, bannerSequence]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  setContent(value) {
    this.props.onChange("bannerDescription", value);
  }
  async uplaodFiles() {
    this.props.sateValChange("btndisabled", true);
    showLoader("dz-details", "class");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#bannerImage");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "banners", "client", 'ecom');
    if (fileDetail.status === "ok") {
      this.props.onChange("bannerImage", fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("dz-details", "class");
    $("#bannerImage").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, e) {
    e.preventDefault();
    showLoader("dz-details", "class");
    var fileDetail = await removeFile(fileNamme, "client", 'ecom');
    if (fileDetail.status === "ok") {
      hideLoader("dz-details", "class");
      this.props.onChange("bannerImage", "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName,
      errMsgSequ,
      errMsgStatus = "";
    if ($validation.bannerTitle.error.reason !== undefined) {
      errMsgName = $validation.bannerTitle.show && (
        <span className="error">{$validation.bannerTitle.error.reason}</span>
      );
    }
    if ($validation.bannerSequence.error.reason !== undefined) {
      errMsgSequ = $validation.bannerSequence.show && (
        <span className="error">
          {$validation.bannerSequence.error.reason}
        </span>
      );
    }
    if ($validation.bannerStatus.error.reason !== undefined) {
      errMsgStatus = $validation.bannerStatus.show && (
        <span className="error">{$validation.bannerStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgName !== "" &&
                  errMsgName !== false &&
                  errMsgName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="bannerTitle"
                value={fields.bannerTitle}
                {...$field("bannerTitle", (e) =>
                  onChange("bannerTitle", e.target.value)
                )}
              />
              <label htmlFor="bannerTitle">
                Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgSequ !== "" &&
                  errMsgSequ !== false &&
                  errMsgSequ !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="bannerSequence"
                value={fields.bannerSequence}
                {...$field("bannerSequence", (e) =>
                  onChange("bannerSequence", e.target.value)
                )}
              />
              <label htmlFor="bannerSequence">Sequence</label>
              {errMsgSequ}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="bannerLink"
                value={fields.bannerLink}
                {...$field("bannerLink", (e) =>
                  onChange("bannerLink", e.target.value)
                )}
              />
              <label htmlFor="bannerLink">Banner Link</label>
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.bannerStatus}
                onChange={this.handleSelectChange.bind(this, "bannerStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            <label>Description</label>
            <Editor
              IDName={"editorContent"}
              data={fields.bannerDescription}
            />
          </div>
          <div className="col-md-6">
            <div
              className="form-floating form-floating-outline mb-4"
              id="ImageContainer"
            >
              <div className="mb-3">
                <label htmlFor="formFile" className="form-label">
                  Banner Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="bannerImage"
                  onChange={(event) => {
                    this.uplaodFiles(event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.bannerImage !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.bannerImage} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href="/"
                  onClick={this.removeImage.bind(this, fields.bannerImage)}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
